import api from './client'
import { Assignment, UserEnrollment, ApiResponse, PaginatedResponse } from '../types'

// Assignment APIs
export const getAssignments = async (): Promise<ApiResponse<Assignment[]>> => {
  const response = await api.get('/assignments/')
  // Handle paginated response
  if (response.data && typeof response.data === 'object' && 'results' in response.data) {
    return {
      data: response.data.results,
      success: true
    }
  }
  return response.data
}

export const getAssignmentById = async (assignmentId: string): Promise<ApiResponse<Assignment>> => {
  const response = await api.get(`/assignments/${assignmentId}/`)
  return response.data
}

export const getAssignmentEnrollments = async (assignmentId: string): Promise<ApiResponse<UserEnrollment[]>> => {
  const response = await api.get(`/assignments/${assignmentId}/enrollments/`)
  return response.data
}

// User Enrollment APIs
export const getUserEnrollments = async (): Promise<ApiResponse<UserEnrollment[]>> => {
  // Use only_mine=true to efficiently get only current user's enrollments from backend
  const response = await api.get<PaginatedResponse<UserEnrollment>>('/user-enrollments/?only_mine=true')
  return { data: response.data.results, success: true }
}

export const getUserEnrollmentById = async (enrollmentId: string): Promise<ApiResponse<UserEnrollment>> => {
  const response = await api.get(`/user-enrollments/${enrollmentId}/`)
  return response.data
}

export const startAssignment = async (enrollmentId: string): Promise<ApiResponse<UserEnrollment>> => {
  const response = await api.post(`/user-enrollments/${enrollmentId}/start/`)
  return response.data
}

export const completeAssignment = async (enrollmentId: string): Promise<ApiResponse<UserEnrollment>> => {
  const response = await api.post(`/user-enrollments/${enrollmentId}/complete/`)
  return response.data
}

// Filter APIs for specific use cases
export const getMyActiveAssignments = async (): Promise<ApiResponse<UserEnrollment[]>> => {
  const data = await fetchAllPages<UserEnrollment>('/user-enrollments/?status=assigned&status=in_progress')
  return { data, success: true }
}

export const getMyCompletedAssignments = async (): Promise<ApiResponse<UserEnrollment[]>> => {
  const data = await fetchAllPages<UserEnrollment>('/user-enrollments/?status=completed')
  return { data, success: true }
}

export const getAssignmentsByType = async (contentType: 'course' | 'assessment'): Promise<ApiResponse<Assignment[]>> => {
  const response = await api.get(`/assignments/?content_type=${contentType}`)
  // Handle paginated response
  if (response.data && typeof response.data === 'object' && 'results' in response.data) {
    return {
      data: response.data.results,
      success: true
    }
  }
  return response.data
}

export const getMandatoryAssignments = async (): Promise<ApiResponse<Assignment[]>> => {
  const response = await api.get('/assignments/?is_mandatory=true')
  // Handle paginated response
  if (response.data && typeof response.data === 'object' && 'results' in response.data) {
    return {
      data: response.data.results,
      success: true
    }
  }
  return response.data
}
